module.exports = __webpack_public_path__ + "img/science.a470bbae.svg";